import { cn } from '@/lib/utils';
import { LogoSpinner } from './LogoSpinner';

interface PageLoaderProps {
	/**
	 * Covers the window, like the boot screen of `index.html` it takes over
	 * from while the first page loads.
	 */
	fullScreen?: boolean;
}

/** Fallback shown while a lazy route is being fetched. */
export function PageLoader({ fullScreen = false }: PageLoaderProps) {
	return (
		<div
			role="status"
			aria-live="polite"
			className={cn(
				'flex w-full flex-col items-center justify-center gap-3',
				fullScreen ? 'bg-background fixed inset-0' : 'min-h-[240px]',
			)}
		>
			<LogoSpinner />
			<span className="text-muted-foreground text-sm">Loading…</span>
		</div>
	);
}
